document.addEventListener("DOMContentLoaded", function () {
  const maxWait = 15000;
  const interval = 300;
  let elapsed = 0;

  const watcher = setInterval(() => {
    elapsed += interval;

    document.querySelectorAll('form[data-id]').forEach(form => {
      if (form.dataset.listenerAttached) return;
      form.dataset.listenerAttached = "true";

      console.log("✅ Globo form detected:", form.dataset.id);

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        const getVal = sel => form.querySelector(sel)?.value.trim() || "";

        const selectedShipping = [...form.querySelectorAll('input[name="checkbox-1[]"]:checked')]
          .map(el => el.value)
          .join(', ');

        const isInpost = selectedShipping.includes("Paczkomat InPost");
        const isPoczta = selectedShipping.includes("Poczta Polska");

        // Dynamic address logic
        let finalAddress = "";
        let phone = "";

        if (isInpost) {
          finalAddress = getVal('input[name="text-3"]'); // Locker address
          phone = getVal('input[name="phone-1"]');
        } 
        else if (isPoczta) {
          finalAddress = getVal('textarea[name="textarea"]'); // Home address
        }

        const payload = {
          formId: form.dataset.id,
          name: getVal('input[name="text-1"]'),
          email: getVal('input[name="email"]'),
          phone: phone,
          deliveryOption: selectedShipping,
          address: finalAddress,
          postCode: getVal('input[name="text-2"]'),
          samplesRequested: getVal('textarea[name="textarea-1"]')
        };

        console.log("📤 Sending:", payload);

        fetch("https://msofas.uk/polska_form.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        })
          .then(res => res.json())
          .then(data => {
            console.log("✅ Sent:", data);
            alert("Form submitted successfully!");
          })
          .catch(err => console.error("❌ Error:", err));
      });
    });

    if (elapsed >= maxWait) {
      clearInterval(watcher);
      console.warn("⏹ Stopped scanning after 15s");
    }

  }, interval);
});
